import { inmunetApi } from '../../../api';

export const eliminarNotificacion = async({ id }) => {

    try {

        const { data } = await inmunetApi.delete(`/notificaciones/${ id }`);

        if (!data.status) throw (data.msg) ? data.msg : 'Error al eliminar notificación';

        return id;

    } catch (error) {

        if (error.response.data.msg) {
            throw new Error(error.response.data.msg);
        } else {
            throw new Error('Error al eliminar notificación');
        }

    }

};